import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { AuthorizeMCPProfile, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

interface AuthorizeMCPProfileResponse {
  ok: boolean;
}

// Records the picked owner profile against the pending handoff named in the redirect URL.
// kilo_mcp reads that row back from the shared DB by token, so no cookie is shared across
// the two domains. The caller then navigates to the original `next` URL to resume OAuth.
export default function useAuthorizeMCPProfile(): UseMutationResult<
  AxiosResponse<AuthorizeMCPProfileResponse>,
  AxiosError<ErrorMessage>,
  AuthorizeMCPProfile
> {
  const mutationFn = ({
    handoff,
    profileId,
  }: AuthorizeMCPProfile): Promise<AxiosResponse<AuthorizeMCPProfileResponse>> => {
    return client.post('mcp/authorize-profile/', { handoff, profileId });
  };

  return useMutation(mutationFn);
}
